<script setup>
import { computed } from 'vue';
import BnToolbarBtn from '@/components/BnToolbarBtn.vue';
import { PERSPECTIVES_GUIDE_URL } from '@/common/config';

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },
});

const emit = defineEmits(['update:modelValue']);

const open = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value),
});

const close = () => {
    open.value = false;
};

const downloadExtension = () => {
    // noopener/noreferrer: window.open does not imply them, and without noopener the vendor page
    // gets a live handle to this authenticated tab and can navigate it.
    window.open(PERSPECTIVES_GUIDE_URL, '_blank', 'noopener,noreferrer');
};
</script>

<template>
    <v-dialog v-model="open" width="500" scrollable persistent data-cy="perspectivesSetupDialog">
        <v-card>
            <v-toolbar density="compact">
                <v-toolbar-title>Perspectives AI enabled</v-toolbar-title>
                <BnToolbarBtn type="secondary" icon="times" label="Close" data-cy="perspectivesSetupClose" @click="close" />
            </v-toolbar>
            <v-card-text class="pa-4">
                <p class="text-body-1 mb-4">Finish the setup to get started using your AI note scribe.</p>

                <div class="d-flex align-start mb-4">
                    <v-avatar color="primary" variant="tonal" size="28" class="mr-3">1</v-avatar>
                    <div>
                        <div class="text-h4">Install Perspectives</div>
                        <v-btn variant="text" color="primary" class="px-0" data-cy="perspectivesSetupDownload" @click="downloadExtension">
                            <font-awesome-icon :icon="['far', 'puzzle-piece']" />
                            <span class="ml-2">Download the extension</span>
                        </v-btn>
                    </div>
                </div>

                <div class="d-flex align-start mb-4">
                    <v-avatar color="primary" variant="tonal" size="28" class="mr-3">2</v-avatar>
                    <div>
                        <div class="text-h4">Return to BestNotes</div>
                        <div class="text-body-2">Come back to this tab when installation is complete.</div>
                    </div>
                </div>

                <div class="d-flex align-start mb-4">
                    <v-avatar color="primary" variant="tonal" size="28" class="mr-3">3</v-avatar>
                    <div class="text-h4">Log out of BestNotes</div>
                </div>

                <div class="d-flex align-start">
                    <v-avatar color="primary" variant="tonal" size="28" class="mr-3">4</v-avatar>
                    <div>
                        <div class="text-h4">Log back in to BestNotes</div>
                        <div class="text-body-2">Perspectives will open automatically using single sign-on.</div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
